var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image",
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-2",
    className: "fill-selector",
    transform: "translate(-652.000000, -544.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-3",
    transform: "translate(652.000000, 544.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image-4",
    d: "M14.7692308,1.04615385 L14.7692308,1.04615385 L14.7692308,12.8615385 L14.7692308,12.8646154 L0.987692308,12.8646154 C0.987692308,12.8646154 0.987692308,12.8646154 0.984615385,12.8615385 L0.984615385,1.04923077 L0.987692308,1.04615385 L14.7692308,1.04615385 Z M14.7692308,0.0615384615 L0.984615385,0.0615384615 C0.443076923,0.0615384615 0,0.504615385 0,1.04615385 L0,12.8615385 C0,13.4030769 0.443076923,13.8461538 0.984615385,13.8461538 L14.7692308,13.8461538 C15.3107692,13.8461538 15.7538462,13.4030769 15.7538462,12.8615385 L15.7538462,1.04615385 C15.7538462,0.504615385 15.3107692,0.0615384615 14.7692308,0.0615384615 L14.7692308,0.0615384615 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-5",
    d: "M12.8,3.50769231 C12.8,4.32307692 12.1384615,4.98461538 11.3230769,4.98461538 C10.5076923,4.98461538 9.84615385,4.32307692 9.84615385,3.50769231 C9.84615385,2.69230769 10.5076923,2.03076923 11.3230769,2.03076923 C12.1384615,2.03076923 12.8,2.69230769 12.8,3.50769231 L12.8,3.50769231 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "image-6",
    points: "13.7846154 11.8769231 1.96923077 11.8769231 1.96923077 9.90769231 5.41538462 4 9.35384615 8.92307692 10.3384615 8.92307692 13.7846154 5.96923077 13.7846154 11.8769231"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e3710f4421f12fa71909763379c41a78.svg";
export { ForwardRef as ReactComponent };